import React from 'react';
import { string } from 'prop-types';

const IconStarHalf = ({ className }) => (
  <svg aria-hidden="true" className={className} width="16.8" height="16" viewBox="0 0 10 10" data-testid="star-half">
    <g fill="none" fillRule="evenodd">
      <path
        fill="transparent"
        d="M5.256 8L2.131 9.648l.597-3.49L.2 3.684l3.494-.509L5.256 0l1.562 3.176 3.494.51-2.528 2.471.597 3.491z"
        strokeWidth="1"
        stroke="rgba(0, 0, 0, 0.25)"
        vectorEffect="non-scaling-stroke"
      />
      <path
        fill="#3483FA"
        d="M5.272 8.026L2.137 9.679l.6-3.502L.2 3.697l3.505-.51L5.272 0z"
        strokeWidth="1"
        stroke="#3483FA"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </svg>
);

IconStarHalf.propTypes = {
  className: string,
};

IconStarHalf.defaultProps = {
  className: '',
};

export default React.memo(IconStarHalf);
